module.exports = __webpack_public_path__ + "static/media/25.sql-developer.173e0ce1.svg";